import type { ScreenerData } from "epsm-api-types/models";
import { greenGradientClassName, redGradientClassName } from "../../../config";

export const getGradientForEmAndRs = (
	screenerData: ScreenerData | null,
): string => {
	if (!screenerData) return "";

	const { em_score, rs_abs_chg_nasdaq, rss_abs_chg_nasdaq } = screenerData;

	const isAnyRsPositive =
		(rs_abs_chg_nasdaq?.ed != null && rs_abs_chg_nasdaq.ed > 0) ||
		(rss_abs_chg_nasdaq?.ed != null && rss_abs_chg_nasdaq.ed > 0);

	if (em_score != null && em_score > 20 && isAnyRsPositive) {
		return greenGradientClassName;
	}

	if (em_score != null && (em_score <= 20 || !isAnyRsPositive)) {
		return redGradientClassName;
	}

	return "";
};
